import ILOTBoard from "@/pages/ILOTPage";

// Pipeline Stage 2 — Packing Schedule (formerly "Upcoming Orders").
// Confirmed orders awaiting dispatch. Marking one delivered moves it to ILOT.
export default function PackingSchedule() {
  return (
    <ILOTBoard
      stage="packing"
      eyebrow="Stage 2 · Awaiting Dispatch"
      title="Packing Schedule"
      subtitle="Confirmed orders awaiting dispatch. Mark an order delivered to move it into ILOT."
      exportName="PackingSchedule"
    />
  );
}
